import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { later } from '@ember/runloop';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';
import { loadScript, uniqueId } from 'webapp/utils/common';

import didInsert from 'webapp/modifiers/did-insert';

export interface Args {
	formId: string;
	prefillEmail: boolean;
	onSubmit: () => void;
	onContentChange: () => void;
}

export default class HubspotFormComponent extends Component<Args> {
	@service('current-user') declare currentUserService: Service.CurrentUser;

	formClass = '';

	constructor(owner: Owner, args: Args) {
		super(owner, args);
		this.formClass = `hubspot-form-${uniqueId()}`;
	}

	loadHubspotScript(cb: () => void) {
		if (window.hbspt?.forms) {
			cb();
		} else {
			loadScript('//js.hsforms.net/forms/v2.js', cb);
		}
	}

	reposition() {
		this.args.onContentChange();
	}

	createHubspotForm() {
		window.hbspt?.forms.create({
			portalId: '518207',
			formId: this.args.formId,
			target: '.' + this.formClass,
			onFormReady: (form: JQuery<HTMLFormElement>) => {
				// Setup a handler to run when the form passes validation
				form.on('hsvalidatedsubmit', () => {
					if (this.args.onSubmit) {
						this.args.onSubmit();
					}
					later(() => {
						this.reposition();
					}, 100);
				});

				if (this.args.prefillEmail) {
					form.find('input[name="email"]')
						.val(this.currentUserService.model?.email || '')
						.trigger('change');
				}

				this.reposition();
			},
		});
	}

	@action
	setupView() {
		this.loadHubspotScript(() => {
			this.createHubspotForm();
		});
	}

	<template>
		<div class={{this.formClass}} {{didInsert this.setupView}}></div>
	</template>
}
